import React, { Component } from 'react';
import './ZoomableDragable.css';
import EfficientMoveCycle from '../ui_core/EfficientMoveCycle';
import TwoFingerTouch from '../ui_core/TwoFingerTouch';
import ParameterErrors from '../errors/ParameterErrors';
import FrequencyLimitedCallback from '../core/FrequencyLimitedCallback';
import GroupedCallbacks from '../core/GroupedCallbacks';
import Once from '../core/Once';
import Handles from '../core/Handles';
import FullScreen from '../ui_core/FullScreen';
import Spinner from './Spinner';
import isDisplaying from '../ui_core/isDisplaying';
const{throwNotProvided}=ParameterErrors;
export default class ParentElement extends Component {
	constructor(props){
		super(props)
		const {getContainerAspectRatio, updateExternalZoomSource, zoomMax, zoomMin, parentElementRef}= props;
		if(updateExternalZoomSource===undefined)throwNotProvided('updateExternalZoomSource');
		if(zoomMax===undefined||zoomMax===null)throwNotProvided('zoomMax');
		if(zoomMin===undefined||zoomMin===null)throwNotProvided('zoomMin');
		if(parentElementRef===undefined||parentElementRef===null)throwNotProvided('parentElementRef');
		this._zoomMin = zoomMin;
		this._zoomMax = zoomMax;
		this._updateExternalZoomSource=updateExternalZoomSource;
		this._getContainerAspectRatio = getContainerAspectRatio;
		this.state ={site:null};
		this._parentElementRef = parentElementRef;
		this._imageWrapper = React.createRef();
		this._inner = React.createRef();
		this._img = React.createRef();
		this._handleDragStart= this._handleDragStart.bind(this);
		this._handleDragMove = this._handleDragMove.bind(this);
		this._handleDragEnd = this._handleDragEnd.bind(this);
		this._handleImageLoaded = this._handleImageLoaded.bind(this);
		this._handleImageError = this._handleImageError.bind(this);
		this._handleWindowResize = this._handleWindowResize.bind(this);
		this._constrainAndSetPositionOfImageWrapper = this._constrainAndSetPositionOfImageWrapper.bind(this);
		this._calculateMaxMinPosition= this._calculateMaxMinPosition.bind(this);
		this._calculateZoomMultiplier= this._calculateZoomMultiplier.bind(this);
		this.setZoom = this.setZoom.bind(this);
		this._setZoomOnce = this._setZoomOnce.bind(this);
		this._onTwoFingerStart= this._onTwoFingerStart.bind(this);
		this._onMoveFinger1= this._onMoveFinger1.bind(this);
		this._onMoveFinger2= this._onMoveFinger2.bind(this);
		this._clearImage= this._clearImage.bind(this);
		this.resizeIfNecessary = this.resizeIfNecessary.bind(this);
		this._resize = this._resize.bind(this);
		this._updateZoomFromTwoFingerTouch = this._updateZoomFromTwoFingerTouch.bind(this);
		this._onTwoFingerEnd = this._onTwoFingerEnd.bind(this);
		this._handleMouseWheelZoom = this._handleMouseWheelZoom.bind(this);
		this._constrainAndSetZoom= this._constrainAndSetZoom.bind(this);
		this._getImgAspectRatio = this._getImgAspectRatio.bind(this);
		this._load = this._load.bind(this);
		this.load = this.load.bind(this);
		this._groupedCallbacksSetZoom= new GroupedCallbacks();
		this.state={imageWrapperPosition:[0, 0], zoom:1, showImage:false};
		this._zoom = 1;
		this._unmultipliedZoom = 1;
		this._onceSetZoom = new Once(this._setZoomOnce);
		this._initialUnmultipliedZoomOnStartOfTwoFingerTouch=null;
		this._zoomMultiplier = 1;
		this._doingTwoFingerTouch=null;
		this._groupedCallbacksImageLoaded = new GroupedCallbacks();
		this._startDistanceTwoFingerTouch=null;
		this._frequencyLimitedCallbackZoom = new FrequencyLimitedCallback({frequencyHz:10});
		this._spinnerHandles = new Handles();
		this._imgUrl = null;
		this._groupedCallbacksImageLoaded.then(()=>{
			this._calculateZoomMultiplier();
			//this.setZoom(1);
		});
		
	}
	setZoom(value){
		return new Promise((resolve, reject)=>{
			this._groupedCallbacksSetZoom.then(resolve).catch(reject); 
			this._onceSetZoom.trigger(value);
		});
	}	
	_calculateZoomMultiplier(){
		if(!this._doneCalculateZoomMultiplier){
			this._doneCalculateZoomMultiplier= true;
			const imgAspectRatio = this._getImgAspectRatio();
			const containerAspectRatio = this._getContainerAspectRatio();
			if(imgAspectRatio>containerAspectRatio)
				this._zoomMultiplier=1;
			else 
				this._zoomMultiplier=imgAspectRatio /containerAspectRatio;
		}
	}
	_getImgAspectRatio(){
		const img = this._img.current;
		const imgAspectRatio = img.naturalWidth/img.naturalHeight;
		return imgAspectRatio;
	}
	_setZoomOnce(value){
		try{
		this._updateExternalZoomSource&&this._updateExternalZoomSource (value);
		this._unmultipliedZoom=value;
		const currentZoom = this._zoom;
		this._zoom = this._zoomMultiplier*value;
		const parentElement = this._parentElementRef.current;
		const imageWrapper = this._imageWrapper.current;
		const multiplier = this._zoom/currentZoom;
		this._calculateMaxMinPosition(imageWrapper.offsetWidth*multiplier, imageWrapper.offsetHeight*multiplier);
		const proportionImageToLeft = (-imageWrapper.offsetLeft+(parentElement.offsetWidth/2))/imageWrapper.offsetWidth;
		const newImageWrapperWidth = imageWrapper.offsetWidth*multiplier;
		const newLeft = (parentElement.offsetWidth/2)-(proportionImageToLeft*newImageWrapperWidth)
		
		
		const proportionImageToTop = (-imageWrapper.offsetTop+(parentElement.offsetHeight/2))/imageWrapper.offsetHeight;
		const newImageWrapperHeight = imageWrapper.offsetHeight*multiplier;
		const newTop = (parentElement.offsetHeight/2)-(proportionImageToTop*newImageWrapperHeight)
		this._constrainAndSetPositionOfImageWrapper(newLeft, newTop, this._zoom);
			this._groupedCallbacksSetZoom.doThen();
		}
		catch(err){
			console.error(err);
			this._groupedCallbacksSetZoom.catch(err);
		}
	}
	get imgUrl(){
		return this._imgUrl;
	}
	_fitToHeight(){
		const imgAspectRatio  = this._getImgAspectRatio();
		const containerAspectRatio = this._getContainerAspectRatio();
		this.setZoom(imgAspectRatio/containerAspectRatio);
	}
	load(imgUrl, fitToHeight){
		this._imgUrl = imgUrl;
		return new Promise((resolve, reject)=>{
			const spinnerHandle = this._spinnerHandles.take();
			const doReject = (err)=>{ 
				spinnerHandle.dispose(); 
				reject(err);
			};
			this._clearImage().then(()=>{
				this.setState({imageWrapperPosition:[0, 0]});
				this._load(imgUrl, fitToHeight).then((res)=>{
					spinnerHandle.dispose(); 
					resolve(res);
				}).catch(doReject);
			}).catch(doReject);
		});
	}
	_load(imgUrl, fitToHeight){
		return new Promise((resolve, reject)=>{
			const imgAlreadyHasUrl=this.state.imgUrl===imgUrl;
			this._zoom = 1;
			this._unmultipliedZoom = 1;
			this._zoomMultiplier = 1;
			this._doneCalculateZoomMultiplier=false;
			this.setState({imgUrl:imgUrl, zoom:1});
			const afterImgLoadIfNecessary =()=>{
				this._calculateZoomMultiplier();
				this.setState({showImage:true});
				if(fitToHeight){
					this._fitToHeight();
				}
				else
				{
					this.setZoom(1);
				}
				resolve();
			};
			if(imgAlreadyHasUrl){
				afterImgLoadIfNecessary();
				return;
			}
			this._groupedCallbacksImageLoaded.then(()=>{
				afterImgLoadIfNecessary();
			}).catch(reject);
		});
	}
	_clearImage(){
		return new Promise((resolve, reject)=>{
			this.setState({imgUrl:'', showImage:false});
			setTimeout(resolve, 0);
		});
	}
	_handleDragStart(e, isTouchElseMouse){
		const parentElement = this._parentElementRef.current;
		const imageWrapper = this._imageWrapper.current;
		const startPosition = [imageWrapper.offsetLeft, imageWrapper.offsetTop];
		this._calculateMaxMinPosition(imageWrapper.offsetWidth, imageWrapper.offsetHeight);
		const screenZParent = isTouchElseMouse?e.touches[0]:e;
		this._startOffset = [startPosition[0]-screenZParent.screenX, startPosition[1]-screenZParent.screenY];
	}
	_calculateMaxMinPosition(widthImageWrapper, heightImageWrapper){
		const parentElement = this._parentElementRef.current;
		const heightParentElement = parentElement.offsetHeight;
		const widthParentElement = parentElement.offsetWidth;
		let minY = heightParentElement-heightImageWrapper;
		if(minY>0)
			minY=minY/2;
		const maxY = minY>0?minY:0;
		let minX = widthParentElement-widthImageWrapper;
		if(minX>0)
			minX=minX/2;
		const maxX=minX>0?minX:0;
		this._maxPosition=[maxX, maxY];
		this._minPosition =[minX, minY];
	}
	_handleDragMove(e, isTouchElseMouse){
		if(this._doingTwoFingerTouch )return;
		const screenZParent = isTouchElseMouse?e.touches[0]:e;
		let newLeft = screenZParent.screenX +this._startOffset[0];
		let newTop = screenZParent.screenY + this._startOffset[1];
		this._constrainAndSetPositionOfImageWrapper(newLeft, newTop, this._zoom);
	}
	_handleDragEnd(e){

	}
	_handleWindowResize(e){
		if((!this._inner.current)||(!isDisplaying(this._inner.current))){
			this._resizeDue = true;
			return;
		}
		this._resize();
	}
	resizeIfNecessary(){
		if((!this._inner.current)||(!isDisplaying(this._inner.current)))return;
		if(this._resizeDue)
		{
			this._resizeDue=false;
			this._resize();
		}
	}
	_resize(){
		this._load(this.state.imgUrl).catch(console.error);
	}
	componentDidMount() {
		this._efficientMoveCycle = new EfficientMoveCycle({
			element: this._imageWrapper.current,
			preventDefault:true,
            onStart: this._handleDragStart,
            onMove: this._handleDragMove,
            onEnd:this._handleDragEnd
		});
		this._twoFingerTouch = new TwoFingerTouch({
			element: this._imageWrapper.current,
            onMoveFinger1: this._onMoveFinger1,
            onMoveFinger2: this._onMoveFinger2,
			onStart:this._onTwoFingerStart,
			onEnd:this._onTwoFingerEnd
		});
		this._imageWrapper.current.addEventListener('wheel', this._handleMouseWheelZoom);
		window.addEventListener('resize', this._handleWindowResize);
		FullScreen.addEventListener('change', this._handleWindowResize);
	}
	_handleMouseWheelZoom(e){
		e.preventDefault();
		const deltaY = e.deltaY;
		const newZoom = this._unmultipliedZoom-(deltaY*0.0016);
		this._constrainAndSetZoom(newZoom);
		return false;
	}
	_onTwoFingerStart(e){
		this._finger1Point = [e.touch1.clientX, e.touch1.clientY];
		this._finger2Point = [e.touch2.clientX, e.touch2.clientY];
		this._startDistanceTwoFingerTouch = this._calculateDistanceBetweenPoints(this._finger1Point, this._finger2Point );
		this._initialUnmultipliedZoomOnStartOfTwoFingerTouch = this._unmultipliedZoom;
		this._doingTwoFingerTouch=true;
	}
	_onMoveFinger1(touch, e){
		if(!this._doingTwoFingerTouch )return;
		this._finger1Point = [touch.clientX, touch.clientY];
		this._updateZoomFromTwoFingerTouch();
	}
	_onMoveFinger2(touch, e){
		if(!this._doingTwoFingerTouch )return;
		this._finger2Point = [touch.clientX, touch.clientY];
		this._updateZoomFromTwoFingerTouch();
	}
	_onTwoFingerEnd(){
		if(this._doingTwoFingerTouch)
			this._updateZoomFromTwoFingerTouch();
		this._doingTwoFingerTouch=false;
	}
	_updateZoomFromTwoFingerTouch(){
		this._frequencyLimitedCallbackZoom.trigger(()=>{
			const newDistance = this._calculateDistanceBetweenPoints(this._finger1Point, this._finger2Point );
			let newUnmultipliedZoom = this._initialUnmultipliedZoomOnStartOfTwoFingerTouch*newDistance/this._startDistanceTwoFingerTouch;
			this._constrainAndSetZoom(newUnmultipliedZoom);
		});
	}
	_constrainAndSetZoom(zoom){
		if(zoom>this._zoomMax)zoom=this._zoomMax;
		if(zoom<this._zoomMin)zoom=this._zoomMin;
		this.setZoom(zoom);
	}
	_calculateDistanceBetweenPoints(a, b){
		return Math.sqrt(Math.pow(b[0]-a[0], 2)+Math.pow(b[1]-a[1], 2))
	}
	_handleImageLoaded(){
		this._groupedCallbacksImageLoaded.doThen();
	}
	_handleImageError(e){
		this._groupedCallbacksImageLoaded.doCatch(new Error(`img with url "${e.target.src}" failed to load`));
	}
	_constrainAndSetPositionOfImageWrapper(newLeft, newTop, zoom){
		const maxX = this._maxPosition[0];
		const maxY = this._maxPosition[1];
		const minX = this._minPosition[0];
		const minY = this._minPosition[1];
		if(newLeft>maxX)
			newLeft =maxX;
		else
			if(newLeft<minX)
				newLeft = minX;
		if(newTop>maxY)
			newTop = maxY;
		else
			if(newTop<minY)
				newTop = minY;
		this.setState({imageWrapperPosition:[newLeft, newTop], zoom:zoom});
	}
	render() {
		const imageWrapperPosition= this.state.imageWrapperPosition;
		let innerClassName = "zoomable-dragable";
		if(this.state.showImage)
			innerClassName+=' show-image';
		return (
			<div className={innerClassName} ref ={this._inner}>
				<div className="image-wrapper" ref={this._imageWrapper}  style={{marginLeft:`${imageWrapperPosition[0]}px`,
					marginTop:`${imageWrapperPosition[1]}px`, width:`${this.state.zoom*100}%`}}>
					<img className="image" ref={this._img} src={this.state.imgUrl}  onLoad={this._handleImageLoaded} onError={this._handleImageError}></img>
					<div className="children">
					{this.props.children}
					</div>
				</div>
				<div className="image-hider"></div>
				<Spinner ref={this._spinnerRef} spinnerHandles={this._spinnerHandles}></Spinner>
			</div>)
	}
}
